// UUIDs. `crypto.randomUUID` exists only in secure contexts, and a dev server
// reached on the LAN over plain http is not one: `getRandomValues` works
// everywhere.

/** The bytes, with their version and RFC 9562 variant set, in the usual hyphenated form. */
function written(bytes: Uint8Array, version: number): string {
  bytes[6] = (bytes[6]! & 0x0f) | (version << 4)
  bytes[8] = (bytes[8]! & 0x3f) | 0x80
  const hex = Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('')
  return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`
}

/** A UUID v4, random: for mutation ids. */
export function uuid4(): string {
  const c = globalThis.crypto
  if (typeof c?.randomUUID === 'function') return c.randomUUID()
  return written(c.getRandomValues(new Uint8Array(16)), 4)
}

/**
 * A UUID v7, for a project or an issue the pages make: its first 48 bits are
 * the time in milliseconds and the rest random, as the server makes ids, so
 * the server's rows still sort by when they were made.
 */
export function uuid7(now: number = Date.now()): string {
  const bytes = globalThis.crypto.getRandomValues(new Uint8Array(16))
  let ms = Math.floor(now)
  for (let i = 5; i >= 0; i--) {
    bytes[i] = ms % 256
    ms = Math.floor(ms / 256)
  }
  return written(bytes, 7)
}
